if (!customElements.get('product-form')) {
	customElements.define(
		'product-form',
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector('form');
				this.form.querySelector('[name=id]').disabled = false;
				this.complementary = document.querySelector('.complementary-product');
				this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
				this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
				this.submitButton = this.querySelector('[type="submit"]');

				if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

				this.hideErrors = this.dataset.hideErrors === 'true';
				this.selectMattressMessage = this.dataset.selectMattressMessage || 'Sélectionnez votre matelas';
				this.selectVariantMessage = this.dataset.selectVariantMessage || 'Sélectionnez une variante';
			}

		onSubmitHandler(evt) {
			if (this.complementary && this.complementary.dataset.open === 'false') {
				evt.preventDefault();
				this.complementary.classList.remove('error');
				setTimeout(() => {
					this.complementary.classList.add('error');
				}, 1);
				return;
			}

			evt.preventDefault();
			if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

			// Vérifier si une variante est sélectionnée
			const variantIdInput = this.form.querySelector('[name="id"]');
			if (!variantIdInput || !variantIdInput.value || variantIdInput.value === '') {
				// Vérifier si c'est un produit complémentaire (matelas)
				const isComplementary = this.form.closest('.complementary-products') || 
				                       this.form.querySelector('.complementary-product') ||
				                       document.querySelector('.complementary-product');
				if (isComplementary) {
					this.handleErrorMessage(this.selectMattressMessage);
					return;
				}
				// Pour les autres produits, utiliser le message par défaut
				this.handleErrorMessage(this.selectVariantMessage);
				return;
			}

			this.handleErrorMessage();

				this.submitButton.setAttribute('aria-disabled', true);
				this.submitButton.classList.add('loading');
				this.querySelector('.loading__spinner').classList.remove('hidden');

				const config = fetchConfig('javascript');
				config.headers['X-Requested-With'] = 'XMLHttpRequest';
				delete config.headers['Content-Type'];

				const formData = new FormData(this.form);
				if (this.cart) {
					formData.append(
						'sections',
						this.cart.getSectionsToRender().map((section) => section.section));
					formData.append('sections_url', window.location.pathname);
					this.cart.setActiveElement(document.activeElement);
				}
				config.body = formData;

				fetch(`${routes.cart_add_url}`, config)
					.then((response) => response.json())
				.then((response) => {
					if (response.status) {
						publish(PUB_SUB_EVENTS.cartError, {
							source: 'product-form',
							productVariantId: formData.get('id'),
							errors: response.errors || response.description,
							message: response.message,
						});
						
						// Remplacer le message d'erreur technique par un message convivial
						let errorMessage = response.description;
						if (errorMessage && errorMessage.includes('Required parameter missing or invalid: id')) {
							const isComplementary = this.form.closest('.complementary-products') || 
							                       this.form.querySelector('.complementary-product') ||
							                       document.querySelector('.complementary-product');
							if (isComplementary) {
								errorMessage = this.selectMattressMessage;
							} else {
								errorMessage = this.selectVariantMessage;
							}
						}
						this.handleErrorMessage(errorMessage);

							const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
							if (!soldOutMessage) return;
							this.submitButton.setAttribute('aria-disabled', true);
							this.submitButton.querySelector('span').classList.add('hidden');
							soldOutMessage.classList.remove('hidden');
							this.error = true;
							return;
						} else if (!this.cart) {
							window.location = window.routes.cart_url;
							return;
						}

						if (!this.error)
							publish(PUB_SUB_EVENTS.cartUpdate, {
								source: 'product-form',
								productVariantId: formData.get('id'),
								cartData: response,
							});
						this.error = false;
						const quickAddModal = this.closest('quick-add-modal');
						if (quickAddModal) {
							document.body.addEventListener(
								'modalClosed',
								() => {
									setTimeout(() => {
										this.cart.renderContents(response);
									});
								},
								{once: true}
							);
							quickAddModal.hide(true);
						} else {
							this.cart.renderContents(response);
						}
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => {
						this.submitButton.classList.remove('loading');
						if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
						if (!this.error) this.submitButton.removeAttribute('aria-disabled');
						this.querySelector('.loading__spinner').classList.add('hidden');
					});
			}

			handleErrorMessage(errorMessage = false) {
				if (this.hideErrors) return;

				this.errorMessageWrapper =
					this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
				if (!this.errorMessageWrapper) return;
				this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

				this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}
		}
	);
}
